import { render, staticRenderFns } from "./UserBalanceBalances.vue?vue&type=template&id=13270d07&scoped=true&"
import script from "./UserBalanceBalances.vue?vue&type=script&lang=js&"
export * from "./UserBalanceBalances.vue?vue&type=script&lang=js&"
import style0 from "./UserBalanceBalances.vue?vue&type=style&index=0&id=13270d07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13270d07",
  null
  
)

export default component.exports